// French (FR)
export const fr = {
  // Navigation
  home: "Accueil",
  back: "Retour",
  products: "Produits",
  contact: "Contact",
  support: "Support",
  login: "Connexion",
  register: "S'inscrire",
  admin: "Admin",
  logout: "Déconnexion",

  // Home Page
  fastDelivery: "Livraison Rapide",
  viewProducts: "Voir les Produits",
  getInTouch: "Nous Contacter",

  // Products
  allProducts: "Tous les Produits",
  addToCart: "Ajouter au Panier",
  price: "Prix",
  originalPrice: "Prix Original",
  quantity: "Quantité",
  reviews: "Avis",

  // Product Detail
  productDetails: "Détails du Produit",
  weight: "Poids",
  shelfLife: "Durée de Conservation",
  ingredients: "Ingrédients",
  allergens: "Allergènes",
  aboutProduct: "À Propos du Produit",
  youMayAlsoLike: "Vous Aimerez Aussi",

  // Cart
  shoppingCart: "Panier d'Achat",
  cartEmpty: "Votre panier est vide",
  continueShopping: "Continuer les Achats",
  proceedToCheckout: "Procéder au Paiement",
  removeItem: "Supprimer",
  cartEmptyDesc: "Vous n'avez pas encore ajouté de produits à votre panier. Visitez notre page produits pour découvrir nos délicieuses gourmandises !",
  itemsInCart: "{count} articles dans votre panier",
  cartContents: "Contenu du Panier",
  clearCart: "Vider le Panier",
  confirmClearCart: "Êtes-vous sûr de vouloir vider complètement votre panier ?",
  orderSummary: "Résumé de la Commande",
  calculatingShipping: "Calcul en cours...",
  shippingCalculatedAtCheckout: "Calculé lors du paiement",

  // Checkout
  checkout: "Paiement",
  paymentMethod: "Méthode de Paiement",
  firstName: "Prénom",
  lastName: "Nom",
  city: "Ville",
  postalCode: "Code Postal",
  agreeTerms: "J'accepte les termes et conditions",
  checkoutSubtitle: "Entrez vos informations pour finaliser votre commande",
  guestCardOnlyNotice: "Les commandes en tant qu'invité ne peuvent être payées que par carte.",
  termsAndConditions: "Conditions Générales",
  agreeTermsAndPrivacy: "J'ai lu et j'accepte les {terms} et la {privacy}.",
  qtyUnit: "unités",
  backToCart: "Retour au Panier",
  sslEncryption: "Chiffrement SSL 256 bits",
  enterCityForShipping: "Saisissez votre ville",
  orderCreationFailed: "La commande n'a pas pu être créée.",
  orderCreationError: "Une erreur s'est produite lors de la création de votre commande.",
  checkoutEmptyCartDesc: "Vous devez ajouter des produits à votre panier avant de pouvoir passer à la caisse.",
  downloading: "Téléchargement...",
  invoiceDownloadFailed: "La facture n'a pas pu être téléchargée. Veuillez réessayer plus tard.",

  // Order
  orderSuccess: "Commande Réussie!",
  orderSuccessMessage: "Votre commande a été traitée avec succès. Nous vous enverrons les détails de la commande par e-mail sous peu.",
  orderDetails: "Détails de la Commande",
  orderNumber: "N° de Commande",
  date: "Date",
  status: "Statut",
  confirmed: "Confirmé",
  emailConfirmation: "Confirmation E-mail",
  emailConfirmationDesc: "Vérifiez l'e-mail contenant les détails de votre commande",
  preparing: "Préparation",
  preparingDesc: "Vos produits sont soigneusement préparés",
  delivery: "Livraison",
  deliveryDesc: "Des produits frais arrivent à votre porte",
  trackOrder: "Suivre la Commande",

  // Order Tracking
  trackYourOrder: "Suivez Votre Commande",
  enterOrderId: "Entrez l'ID de commande ou le numéro de suivi",
  orderNotFound: "Commande non trouvée",
  shippingAddress: "Adresse de Livraison",
  trackingNumber: "Numéro de Suivi",
  orderItems: "Articles de la Commande",
  orderPlaced: "Commande Passée",
  processing: "Traitement",
  shipped: "Expédié",
  outForDelivery: "En Livraison",
  delivered: "Livré",
  estimatedDelivery: "Livraison Estimée",
  downloadInvoice: "Télécharger la Facture",
  packagingStatus: "En cours d'Emballage",
  orderCancelled: "Annulée",
  defaultProductName: "Délice Précieux",
  defaultCustomerName: "Cher Client",
  orderFetchError: "Une erreur s'est produite lors de la récupération des informations de votre commande.",
  awaitingDate: "En attente",
  fetchingOrder: "Récupération de Votre Commande...",
  deliveryJourney: "Parcours de Livraison",
  packageTrackingTitle: "Votre Colis Est-Il {highlight}",
  packageTrackingTitleHighlight: "En Sécurité ?",
  trackOrderInstructions: "Saisissez votre numéro de commande dans le champ ci-dessus pour suivre l'état de votre colis en temps réel.",
  getSupport: "Obtenir de l'Aide",
  backToStore: "Retour à la Boutique",
  orderHistoryLabel: "Historique de la Commande",
  deliveryInfoTitle: "Informations de Livraison",
  needHelpTitle: "Besoin d'Aide ?",
  whatsappHelpText: "Vous pouvez toujours nous contacter au sujet de votre commande via WhatsApp.",
  customerService: "Service Client",
  notSatisfiedTitle: "Pas satisfait de votre produit ?",
  returnExchangeText: "Vous pouvez faire une demande de retour ou d'échange.",
  createReturnRequest: "Créer une Demande de Retour",

  // Cash on Delivery Options
  deliveryOptionsLoadError: "Une erreur s'est produite lors du chargement des options de livraison.",
  loadingDeliveryOptions: "Chargement des options de livraison...",
  codTitle: "Paiement à la Livraison & Options de Livraison",
  noDeliveryScheduleForCity: "Il n'y a actuellement aucun calendrier de livraison pour cette ville.",
  tryDifferentMethodOrLater: "Veuillez choisir une autre méthode de livraison ou réessayer plus tard.",
  currentMonthLabel: "Mois en Cours",
  codAvailable: "Disponible",
  moreDatesAvailable: "+{count} dates supplémentaires disponibles",
  nextMonthLabel: "Mois Prochain",
  codScheduled: "Planifié",
  currentMonthScheduleCompleted: "Le calendrier de livraison de ce mois est terminé",
  currentMonthPassedNextAvailable: "Les dates de livraison prévues pour ce mois sont passées. La livraison est possible le mois prochain.",
  selectedDeliveryDateLabel: "Date de Livraison Sélectionnée",
  activeDeliverySchedules: "Calendriers de Livraison Actifs",

  // Payment Methods
  payWithCard: "Payer par Carte",
  cashOnDeliveryLabel: "Paiement à la Livraison",
  selectPaymentMethod: "Choisissez un Moyen de Paiement",
  noActivePaymentMethod: "Aucun moyen de paiement actif n'est disponible pour le moment. Veuillez contacter l'administrateur.",
  paymentProcessingError: "Une erreur s'est produite lors du paiement.",
  pay: "Payer",
  redirecting: "Redirection en cours...",
  payWithMethod: "Payer avec {method}",
  paymentAmountLabel: "Montant du paiement",
  redirectingToPaymentPage: "Vous allez être redirigé vers la page de paiement.",
  mollieStartFailed: "Le paiement Mollie n'a pas pu être initié.",
  cashOnDeliveryDesc: "Vous pouvez payer en espèces ou par carte à la livraison.",
  confirmOrder: "Confirmer la Commande",
  orderWithPaymentObligation: "Commande avec obligation de paiement",
  cardNotStoredDesc: "Pour votre sécurité, les informations de votre carte ne sont jamais stockées sur nos systèmes. Chaque commande est traitée en toute sécurité via Stripe ou Mollie.",
  calculatingDeliveryDates: "Calcul des dates de livraison...",
  noDeliveryScheduleContact: "Aucun calendrier de livraison n'a encore été défini pour « {city} ». Veuillez nous contacter.",
  deliveryInfoLabel: "Informations de Livraison",
  deliveryDaysLabel: "Jours de livraison :",
  upcomingDeliveryDates: "Prochaines Dates de Livraison",
  freeShippingOverAmount: "Gratuit au-delà de {amount}",
  selectCityLabel: "Choisir une Ville",
  cityListLoadFailed: "La liste des villes n'a pas pu être chargée",
  paymentVerifying: "Vérification du Paiement",
  paymentVerifyingDesc: "Votre paiement est en cours de vérification, veuillez patienter...",
  paymentSuccessful: "Paiement Réussi !",
  orderReceivedRedirecting: "Votre commande a été reçue, vous allez être redirigé...",

  // Reviews
  customerReviews: "Avis Clients",
  writeReview: "Écrire un Avis",
  rating: "Note",
  reviewTitle: "Titre de l'Avis",
  yourReview: "Votre Avis",
  yourName: "Votre Nom",
  yourFullName: "Votre Nom Complet",
  submitReview: "Soumettre l'Avis",
  verified: "Vérifié",
  wasHelpful: "Cet avis était-il utile?",
  yes: "Oui",
  no: "Non",
  noReviewsYet: "Aucun avis pour le moment",
  beFirstToReview: "Soyez le premier à évaluer ce produit!",
  writeFirstReview: "Écrire le Premier Avis",

  // Profile
  personalInfo: "Informations Personnelles",
  profileUpdated: "Profil mis à jour avec succès!",

  // Email Notifications
  emailNotifications: "Notifications E-mail",
  language: "Langue",
  orderConfirmations: "Confirmations de Commande",
  orderConfirmationsDesc: "Recevez des e-mails de confirmation lorsque vous passez une commande",
  shippingUpdates: "Mises à Jour d'Expédition",
  shippingUpdatesDesc: "Soyez notifié lorsque votre commande est expédiée",
  deliveryNotifications: "Notifications de Livraison",
  deliveryNotificationsDesc: "Recevez des notifications lorsque votre commande est livrée",
  marketingEmails: "E-mails Marketing",
  marketingEmailsDesc: "Recevez des e-mails promotionnels et des offres spéciales",
  newsletter: "Newsletter",
  newsletterDesc: "Restez informé de nos dernières nouvelles et produits",
  productRecommendations: "Recommandations de Produits",
  productRecommendationsDesc: "Obtenez des recommandations de produits personnalisées",
  reviewReminders: "Rappels d'Avis",
  reviewRemindersDesc: "Rappels pour évaluer les produits que vous avez achetés",
  specialOffers: "Offres Spéciales",
  specialOffersDesc: "Offres exclusives et réductions",
  birthdayOffers: "Offres d'Anniversaire",
  birthdayOffersDesc: "Offres spéciales pour votre anniversaire",
  emailFrequency: "Fréquence des E-mails",
  emailFrequencyDesc: "Nous respectons votre boîte de réception et n'enverrons que des e-mails pertinents. Vous pouvez modifier ces paramètres à tout moment.",

  // Wishlist
  wishlist: "Liste de Souhaits",
  myWishlist: "Ma Liste de Souhaits",
  wishlistEmpty: "Votre Liste de Souhaits est Vide",
  wishlistEmptyDesc: "Vous n'avez pas encore ajouté de produits à votre liste de souhaits. Cliquez sur l'icône cœur sur les produits que vous aimez pour les ajouter à votre liste de souhaits.",
  removeFromWishlist: "Retirer de la Liste de Souhaits",
  wishlistItemsCount: "Vous avez {count} articles dans votre liste de souhaits",
  addAllToCart: "Tout Ajouter au Panier",
  clearWishlist: "Vider la Liste de Souhaits",
  clearWishlistConfirm: "Êtes-vous sûr de vouloir vider votre liste de souhaits?",
  totalValue: "Valeur Totale",
  addedToCart: "ajouté au panier!",
  allItemsAddedToCart: "Tous les articles ajoutés au panier!",
  startShopping: "Commencer les Achats",
  lastUpdatedLabel: "Dernière Mise à Jour",

  // Coupons
  haveCoupon: "Avez-vous un Code Promo?",
  enterCouponCode: "Entrez le code promo",
  apply: "Appliquer",
  couponApplied: "Coupon Appliqué",
  invalidCoupon: "Code promo invalide",
  couponExpired: "Le coupon a expiré",
  minPurchaseNotMet: "Montant minimum d'achat non atteint",
  couponError: "Erreur de coupon",
  availableCoupons: "Coupons Disponibles",
  couponCopied: "Coupon copié",
  validUntil: "Valable Jusqu'au",
  minPurchase: "Achat Min.",
  copy: "Copier",
  freeShipping: "Livraison Gratuite",

  // Social Media
  share: "Partager",
  linkCopied: "Lien copié !",
  followUsOn: "Suivez-nous sur",

  // FAQ
  frequentlyAskedQuestions: "Questions Fréquemment Posées",
  faqQuestion1: "Comment puis-je suivre ma commande?",
  faqAnswer1: "Vous pouvez suivre votre commande en entrant votre numéro de commande sur la page 'Suivi de Commande' ou en utilisant le lien de suivi envoyé par e-mail.",
  faqQuestion2: "Quel est le délai de livraison?",
  faqAnswer2: "Notre délai de livraison vers la Belgique et les Pays-Bas est de 3-5 jours ouvrables. Pour les cas spéciaux, vous pouvez contacter notre service client.",
  faqQuestion3: "Quelles méthodes de paiement acceptez-vous?",
  faqAnswer3: "Vous pouvez payer par carte de crédit, virement bancaire et PayPal. Tous les paiements sont traités de manière sécurisée.",
  faqQuestion4: "Quelle est la politique de retour?",
  faqAnswer4: "Vous pouvez contacter notre équipe de support dans les 2 jours suivant la livraison de vos produits.",
  faqQuestion5: "Vos produits sont-ils naturels?",
  faqAnswer5: "Oui, tous nos produits sont préparés avec des ingrédients naturels. Ils ne contiennent aucun conservateur ou additif artificiel.",
  faqQuestion6: "Comment puis-je devenir membre?",
  faqAnswer6: "Vous pouvez créer un compte gratuit en cliquant sur le bouton 'S'inscrire' dans le coin supérieur droit. Vous pouvez vous inscrire facilement avec votre adresse e-mail et votre mot de passe.",
  faqQuestion7: "Vos produits sont-ils certifiés halal?",
  faqAnswer7: "Oui, tous nos produits sont certifiés halal. Nous nous assurons de la conformité aux normes halal dans nos processus de production et sommes régulièrement audités. Nous sommes heureux de partager nos certificats avec nos clients.",
  faqQuestion8: "La valeur nutritionnelle des produits congelés est-elle préservée?",
  faqAnswer8: "Oui, nous utilisons la technologie de congélation rapide pour préserver la valeur nutritionnelle et le goût de nos produits. Ainsi, vous obtenez le goût comme s'ils étaient préparés frais.",
  faqQuestion9: "Vos produits contiennent-ils des additifs?",
  faqAnswer9: "Non, nous n'utilisons pas d'additifs artificiels dans nos produits. Nos produits, préparés avec des méthodes traditionnelles et des ingrédients naturels, sont à la fois sains et délicieux.",

  // About Page
  aboutUs: "À Propos",
  ourStory: "Notre Histoire",
  ourStoryText: "Eticaret est né avec la vision d'apporter la tradition culinaire turque enracinée au monde moderne. En combinant les recettes de nos grands-mères transmises de génération en génération avec les normes d'hygiène et les possibilités technologiques d'aujourd'hui, nous permettons à chacun d'expérimenter les saveurs traditionnelles à la maison.",
  ourMissionText: "Notre objectif n'est pas seulement d'offrir des produits délicieux, mais aussi de présenter la richesse de la culture turque au monde. Chacun de nos produits est préparé selon des méthodes traditionnelles, emballé de manière hygiénique et livré à tous sous forme de produits congelés.",
  halalCertified: "Certifié Halal",
  ourValues: "Nos Valeurs",
  traditionalCraftsmanship: "Savoir-faire Traditionnel",
  traditionalCraftsmanshipText: "Chacun de nos produits est préparé avec des années d'expérience et d'amour. Nous présentons nos recettes traditionnelles en les mélangeant avec des techniques modernes.",
  qualityAssurance: "Assurance Qualité",
  qualityAssuranceText: "Nous privilégions la satisfaction client avec nos produits soigneusement contrôlés à chaque étape en utilisant les matériaux de la plus haute qualité.",
  halalCertifiedValue: "Certifié Halal",
  halalCertifiedValueText: "Tous nos produits sont certifiés halal et nous gagnons la confiance de nos clients qui ont des sensibilités religieuses.",
  followUsText: "Vous pouvez suivre nos dernières nouvelles sur nos comptes de médias sociaux et rester informé de nos nouveaux produits.",
  ourProductionProcess: "Notre Processus de Production",
  freezingTechnology: "Technologie de Congélation",
  freezingTechnologyText: "Nous préservons le goût et la valeur nutritionnelle avec la technologie de congélation rapide.",
  qualityAndHygiene: "Qualité et Hygiène",
  qualityAndHygieneText: "Nous produisons dans des conditions hygiéniques selon les normes européennes avec les matériaux de la plus haute qualité.",
  globalAccess: "Accès Mondial",
  globalAccessText: "Nous livrons les saveurs turques partout dans le monde avec la technologie des produits congelés.",
  followUsOnSocialMedia: "Suivez-nous sur les Médias Sociaux",
  followUsOnSocialMediaText: "Suivez les histoires de nos saveurs traditionnelles, nos processus de production et nos campagnes spéciales sur les médias sociaux !",
  aboutHeroTagline: "De la Tradition à l'Avenir",
  aboutHeroTitlePrefix: "L'Histoire Ancienne",
  aboutHeroTitleHighlight: "de l'Anatolie",
  aboutHeroQuote: "Un héritage de saveurs millénaire, pétri par la richesse de la terre, mûri par le feu et transformé en art par les mains des maîtres.",
  aboutHeritageTitlePrefix: "Mille Ans",
  aboutHeritageTitleHighlight: "au Rythme du Feu",
  aboutNaturalContentLabel: "Contenu Naturel",
  aboutTraditionalRecipeLabel: "Recettes Traditionnelles",
  aboutCraftsmanshipTitle: "Précision Artisanale, Patience Anatolienne",
  aboutValuesTitlePrefix: "Ce qui Nous Est",
  aboutValuesTitleHighlight: "Sacré",
  categoryGeneral: "Général",
  categoryOrder: "Commande",
  categoryProduct: "Produit",
  categoryPayment: "Paiement",
  categoryShipping: "Livraison",
  categoryTechnical: "Technique",
  categoryComplaint: "Réclamation",
  categorySuggestion: "Suggestion",
  priorityLabel: "Priorité",
  priorityLow: "Faible",
  priorityMedium: "Moyenne",
  priorityHigh: "Élevée",
  priorityUrgent: "Urgente",
  selectSubject: "Sélectionnez un sujet",
  subjectInfo: "Information",
  subjectOther: "Autre",
  namePlaceholder: "Votre nom complet",
  emailPlaceholder: "exemple@email.com",
  phonePlaceholder: "+32 555 123 456",
  messagePlaceholder: "Écrivez votre message ici...",
  createSupportTicket: "Créer un Ticket de Support",
  ticketCreatedSuccess: "Votre ticket de support a été créé avec succès ! Numéro de ticket : {ticketNumber}",
  ticketCreationError: "Une erreur s'est produite lors de la création de votre ticket de support. Veuillez réessayer.",
  socialMedia: "Réseaux Sociaux",

  // Contact Page
  contactUs: "Contact",
  contactDescription: "Contactez-nous. Nous sommes heureux de répondre à vos questions et de vous aider.",
  contactForm: "Formulaire de Contact",
  contactFormDescription: "Vous pouvez nous contacter en remplissant le formulaire ci-dessous. Nous vous répondrons dans les plus brefs délais.",
  subject: "Sujet",
  yourMessage: "Votre Message",
  country: "Pays",
  address: "Adresse",
  phone: "Téléphone",
  email: "E-mail",

  // Support Page
  customerSupport: "Support Client",
  supportDescription: "Comment pouvons-nous vous aider? Nous sommes là pour répondre à vos questions et résoudre vos problèmes.",
  needMoreHelp: "Besoin de Plus d'Aide?",
  contactUsDirectly: "Contactez-nous directement",
  emailSupportDesc: "Réponse sous 24 heures",
  sendEmail: "Envoyer un E-mail",
  whatsappSupport: "Support WhatsApp",
  whatsappSupportDesc: "Messagerie rapide",
  whatsappGreetingMessage: "Bonjour ! J'aimerais obtenir de l'aide.",
  messageWhatsApp: "Message sur WhatsApp",

  // Live Support
  online: "En ligne",
  offline: "Hors ligne",

  // Footer
  followUs: "Suivez-Nous",
  quickLinks: "Liens Rapides",
  categories: "Catégories",
  desserts: "Desserts",
  contactInfo: "Informations de Contact",
  allRightsReserved: "Tous droits réservés.",
  privacyPolicy: "Politique de Confidentialité",
  paymentMethods: "Méthodes de Paiement",
  workingHours: "Heures d'Ouverture",

  // Footer Newsletter & Trust
  worldOfPrivileges: "Monde de Privilèges",
  newsletterTitleLine1: "Soyez les Premiers Informés",
  newsletterTitleHighlight: "des Saveurs du Palais",
  newsletterDescriptionFooter: "Soyez les premiers informés de nos nouveaux produits, de nos saveurs en édition limitée et des offres exclusives réservées à nos abonnés.",
  subscribe: "S'abonner",
  unsubscribeNote: "* Vous pouvez vous désabonner à tout moment.",
  footerBrandDescription: "Nous mêlons les traditions millénaires de l'Anatolie aux ingrédients les plus frais pour les apporter sur votre table avec une présentation moderne. Nous vous servons avec une approche de production artisanale qui ne fait jamais de compromis sur la qualité.",
  footerFavoriteFlavors: "Saveurs Préférées",
  footerCategoryDesserts: "Desserts & Gâteaux",
  footerCategoryPastries: "Pâtisseries & Börek",
  footerCategoryMains: "Plats Traditionnels",
  footerCategoryIceCream: "Glaces & Desserts Froids",
  footerCategoryGrocery: "Épicerie & Céréales",
  headOffice: "Siège Social",
  customerLine: "Ligne Client",
  naturalContentTrustDesc: "Aucun conservateur, colorant artificiel ou sirop de maïs n'est utilisé dans nos produits.",
  coldChainDelivery: "Livraison en Chaîne du Froid",
  coldChainDeliveryDesc: "Grâce à notre système d'emballage spécial, nous livrons des produits frais partout en Belgique en 48 heures.",
  securePaymentInfrastructure: "Infrastructure de Paiement Sécurisée",
  securePaymentInfrastructureDesc: "Tous vos paiements sont protégés par SSL 256 bits, garantis par Stripe et Bancontact.",
  distanceSalesAgreement: "Accord de Vente à Distance",

  // Hero Banner
  heroDefaultTitle: "Cuisine Turque",
  heroDefaultSubtitle: "Saveurs Traditionnelles Turques",
  heroDefaultDescription: "Des saveurs de palais façonnées par des mains expertes avec des ingrédients 100% naturels, maintenant à votre porte.",
  heroDefaultButtonText: "Découvrir Maintenant",
  heroDefaultBadge: "Sélection Spéciale",
  heroLoadingText: "Préparation de la Cuisine du Palais...",

  // Home Page (main hero & sections)
  homeSeoTitle: "Eticaret — Saveurs Traditionnelles Turques",
  homeSeoDescription: "Livré en Belgique : baklava, börek, manti, glace et plus encore. Frais, congelé, à votre porte.",
  homeHeroFreeShippingBadge: "Livraison Gratuite en Belgique — Dès €50",
  homeHeroTitleLine1: "Les Saveurs",
  homeHeroTitleHighlight: "les Plus Fraîches",
  homeHeroTitleSuffix: "d'Anatolie",
  homeHeroDescription: "Baklava, börek, manti, glace — congelés et frais. Livrés chez vous.",
  promoFreeShippingOver50: "Livraison Gratuite Dès €50",
  promoFrozenFreshDelivery: "Congelé — Livré Frais",
  promoNaturalIngredient: "Ingrédients Naturels",
  promoSecurePayment: "Paiement Sécurisé",
  featuredProductsTitle: "Produits Vedettes",
  viewAll: "Tout Voir",
  campaignsTitle: "Promotions",
  campaignsBadge: "Durée Limitée",
  campaignsSubtitle: "Offres remisées sur une sélection de produits",
  viewAllCampaigns: "Voir Toutes les Promotions",
  campaignsSaving: "d'économie",
  campaignsEmpty: "Il n'y a actuellement aucune offre groupée active.",
  collectionLabel: "Collection",
  whyEticaret: "Pourquoi Eticaret ?",
  whyEticaretSubtitle: "Nous vous proposons le meilleur",
  whyFrozenFreshTitle: "Congelé Frais",
  whyFrozenFreshDesc: "Nos produits sont préparés avec les recettes les plus fraîches et instantanément congélés, préservant ainsi le goût et la valeur nutritionnelle. La congélation arrête la croissance microbienne, garantissant que vos produits restent frais plus longtemps.",
  whyBelgiumWideTitle: "Toute la Belgique",
  whyBelgiumWideDesc: "Livraison gratuite partout en Belgique pour les commandes de plus de €50. Notre réseau logistique rapide et sécurisé garantit que votre commande arrive rapidement et en toute sécurité. Chaque expédition inclut un suivi et une surveillance.",
  whyAllNaturalTitle: "100% Naturel",
  whyAllNaturalDesc: "Tous nos produits sont préparés avec des ingrédients naturels, sans additifs, colorants ni édulcorants artificiels. En suivant des recettes traditionnelles, nous vous proposons des saveurs pures et authentiques, comme les plats faits maison.",
  whySecurePaymentTitle: "Paiement Sécurisé",
  whySecurePaymentDesc: "Paiement à la livraison, paiement par carte ou paiement en ligne sécurisé via Stripe/Mollie. Toutes les transactions sont protégées par chiffrement SSL.",
  ctaDiscoverAllProducts: "Découvrir Tous les Produits",
  ctaProductCountDesc: "31 produits traditionnels, livrés à votre porte",

  // Common
  loading: "Chargement...",
  connectionRestored: "Connexion rétablie !",
  noInternetConnection: "Pas de connexion internet",
  cartTooltip: "Mon Panier ({count} articles)",
  skipToMainContent: "Aller au contenu principal",
  error: "Erreur",
  success: "Succès",
  discountAmount: "Réduction",
  cancel: "Annuler",
  save: "Sauvegarder",
  edit: "Modifier",
  add: "Ajouter",
  view: "Voir",
  submit: "Soumettre",
  total: "Total",
  subtotal: "Sous-total",
  tax: "Taxe",
  shipping: "Expédition",
  discount: "Réduction",
  free: "Gratuit",

  // Inventory Management
  overview: "Aperçu",
  alerts: "Alertes",
  outOfStock: "Rupture de Stock",
  inStock: "En Stock",
  product: "Produit",
  minStock: "Stock Min.",

  // Search & Filters
  searchPlaceholder: "Rechercher des produits...",
  suggestions: "Suggestions",
  recentSearches: "Recherches Récentes",
  filters: "Filtres",
  category: "Catégorie",
  subcategory: "Sous-catégorie",
  allSubcategories: "Toutes les Sous-catégories",
  priceRange: "Fourchette de Prix",
  newProducts: "Nouveaux Produits",
  recommendedForYou: "Recommandé Pour Vous",
  popular: "Populaire",
  onSale: "En Promotion",
  brand: "Marque",
  origin: "Origine",
  sortBy: "Trier Par",
  relevance: "Pertinence",
  priceLow: "Prix (Bas-Élevé)",
  priceHigh: "Prix (Élevé-Bas)",
  newest: "Plus Récent",
  name: "Nom",
  searching: "Recherche",
  showAllProducts: "Afficher Tous les Produits",
  unknown: "Inconnu",

  // Admin Dashboard
  orders: "Commandes",
  customers: "Clients",
  reports: "Rapports",
  settings: "Paramètres",
  totalOrders: "Total des Commandes",
  totalRevenue: "Chiffre d'Affaires Total",
  totalCustomers: "Total des Clients",

  // Analytics & Reporting
  analyticsDashboard: "Tableau de Bord Analytique",
  businessOverview: "Aperçu de l'Entreprise",
  salesAnalytics: "Analyse des Ventes",
  customerAnalytics: "Analyse des Clients",
  inventoryAnalytics: "Analyse des Stocks",
  marketingAnalytics: "Analyse Marketing",
  reportsAndExports: "Rapports et Exports",
  last7Days: "7 Derniers Jours",
  last30Days: "30 Derniers Jours",
  last90Days: "90 Derniers Jours",
  lastYear: "Année Dernière",
  dateRange: "Plage de Dates",
  vsLastMonth: "vs Mois Dernier",
  averageOrderValue: "Valeur Moyenne de la Commande",
  conversionRate: "Taux de Conversion",
  newCustomers: "Nouveaux Clients",
  averageCustomerValue: "Valeur Moyenne du Client",
  turnoverRate: "Taux de Rotation",
  averageStockDays: "Jours Moyens de Stock",
  totalVisitors: "Total des Visiteurs",
  uniqueVisitors: "Visiteurs Uniques",
  bounceRate: "Taux de Rebond",
  avgSessionDuration: "Durée Moy. de Session",
  revenueTrend: "Tendance des Revenus",
  revenueByCategory: "Revenus par Catégorie",
  customerSegments: "Segments de Clients",
  trafficSources: "Sources de Trafic",
  conversionFunnel: "Entonnoir de Conversion",
  topMovingProducts: "Produits les Plus Vendus",
  unitsSold: "Unités Vendues",
  generateReport: "Générer un Rapport",
  exportData: "Exporter les Données",
  reportType: "Type de Rapport",
  salesReport: "Rapport de Ventes",
  customerReport: "Rapport Client",
  inventoryReport: "Rapport de Stock",
  marketingReport: "Rapport Marketing",
  comprehensiveReport: "Rapport Complet",
  generatePDF: "Générer un PDF",
  generateExcel: "Générer un Excel",
  exportSalesData: "Exporter les Données de Ventes",
  exportCustomerData: "Exporter les Données Clients",
  exportInventoryData: "Exporter les Données de Stock",
  exportMarketingData: "Exporter les Données Marketing",

  // Navigation
  confirmLogout: "Êtes-vous sûr de vouloir vous déconnecter?",
  collections: "Collections",
  collectionsMenuTitleLine1: "Découvertes Spéciales",
  collectionsMenuTitleHighlight: "D'Anatolie",
  collectionsMenuSubtitle: "Recettes Traditionnelles, Présentations Modernes",
  viewAllCollections: "Voir Toute la Collection",
  discover: "Découvrir",
  sustainableShipping: "Livraison Durable",
  allNaturalContent: "Contenu 100% Naturel",
  allCategoryProducts: "Tous les Produits {category}",
  logoAlt: "Logo",
  cookiePolicy: "Politique de Cookies",
  termsOfUse: "Conditions d'Utilisation",
  cookieUsageTitle: "Utilisation des Cookies",
  cookieUsageDescPrefix: "En utilisant notre site, nous utilisons des cookies pour améliorer les performances de notre site web et vous offrir un meilleur service. Pour plus de détails, veuillez lire notre",
  cookieUsageDescSuffix: ".",
  onlyNecessary: "Uniquement Nécessaires",
  acceptAll: "Tout Accepter",
  cookiePreferencesTitle: "Préférences de Cookies",
  cookiePreferencesDesc: "Vous pouvez choisir quels cookies vous souhaitez accepter",
  necessaryCookiesTitle: "Cookies Nécessaires",
  alwaysActive: "Toujours actifs",
  necessaryCookiesDesc: "Nécessaires au fonctionnement des fonctions de base du site. Ils ne peuvent pas être désactivés.",
  performanceCookiesTitle: "Cookies de Performance",
  performanceCookiesDesc: "Utilisés pour analyser les performances du site et l'expérience utilisateur.",
  examplesLabel: "Exemples",
  functionalCookiesTitle: "Cookies Fonctionnels",
  functionalCookiesDesc: "Utilisés pour mémoriser vos préférences et offrir une expérience personnalisée.",
  functionalCookiesExamples: "Préférences de langue, paramètres régionaux",
  marketingCookiesTitle: "Cookies Marketing",
  marketingCookiesDesc: "Utilisés pour vous montrer des publicités plus pertinentes et pour l'analyse marketing.",
  saveMyPreferences: "Enregistrer Mes Préférences",
  
  // Email Verification
  emailVerification: "Vérification d'Email",
  emailVerificationRequired: "Vérification d'Email Requise",
  emailVerificationMessage: "Veuillez cliquer sur le lien de vérification envoyé à {email} pour vérifier votre adresse email.",
  emailVerifiedSuccessfully: "Email Vérifié avec Succès",
  emailVerifiedMessage: "Votre adresse email a été vérifiée avec succès. Vous pouvez maintenant profiter de toutes les fonctionnalités.",
  emailVerificationFailed: "Échec de la Vérification d'Email",
  emailVerificationFailedMessage: "La vérification d'email a échoué. Veuillez réessayer.",
  checkYourEmail: "Vérifiez Votre Email",
  emailVerificationInstructions: "Cliquez sur le lien de vérification envoyé à votre adresse email pour vérifier votre compte.",
  resendVerificationEmail: "Renvoyer l'Email de Vérification",
  resendVerificationDescription: "Remplissez le formulaire ci-dessous pour envoyer un email de vérification à votre adresse email.",
  sendVerificationEmail: "Envoyer l'Email de Vérification",
  verifyingEmail: "Vérification de l'email...",
  verificationStatusCheckFailed: "Impossible de vérifier le statut de vérification de l'email",
  verificationEmailSent: "E-mail de vérification envoyé",
  verificationEmailSendFailed: "L'e-mail n'a pas pu être envoyé",
  pleaseWaitSeconds: "Veuillez patienter {seconds} secondes",
  continueToProfile: "Continuer vers le Profil",
  backToProfile: "Retour au Profil",
  backToHome: "Retour à l'Accueil",
  resendIn: "Renvoyer dans",
  sending: "Envoi en cours...",
  dismiss: "Fermer",
  needHelp: "Besoin d'aide?",
  didntReceiveEmail: "Vous n'avez pas reçu l'email?",
  checkSpamFolder: "Vérifiez votre dossier spam et assurez-vous que l'email n'a pas été marqué comme spam.",
  wrongEmailAddress: "Mauvaise adresse email?",
  contactSupportMessage: "Contactez notre équipe de support.",
  verificationLinkExpired: "Le lien de vérification a expiré?",
  requestNewVerification: "Demandez un nouvel email de vérification.",
  pleaseEnterEmail: "Veuillez entrer votre adresse email.",
  emailAddress: "Adresse Email",
  enterEmailAddress: "Entrez votre adresse email",

  // Products Page
  anatolianCollectionLabel: "Collection Anatolienne",
  listedProducts: "Répertoriés",
  noResultsTitle: "Rien Ne Correspond Pour L'instant",
  noResultsDescription: "Nous n'avons trouvé aucun produit correspondant à vos critères. Veuillez réinitialiser les filtres et réessayer.",

  // Product Card
  newLabel: "Nouveau",
  addingToCart: "Ajout en cours...",
  quickAdd: "AJOUT RAPIDE",

  // Product Detail
  productNotFound: "Produit Introuvable",
  productNotFoundDesc: "Le produit que vous recherchez n'existe pas ou a été retiré.",
  backToProducts: "Retour aux Produits",
  selectionRequired: "* Veuillez sélectionner",
  lastUnitsLeft: "(Plus que {count})",
  selectVariant: "Sélectionnez une Variante",
  readReturnPolicy: "Vous pouvez consulter notre politique de retour ici",
  codPaymentNote: "Le paiement à la livraison peut être disponible ; la confirmation finale dépend de votre adresse lors du paiement.",
  selectCityForDelivery: "Sélectionnez votre ville ci-dessus pour voir les jours de livraison et la disponibilité du paiement à la livraison.",
  productCode: "Code Produit",
  nutritionalValues: "Valeurs Nutritionnelles",

  // Product Filters
  filterOptionsHeading: "Options",
  reset: "Réinitialiser",
  allPrefix: "TOUS",
  preferences: "Préférences",
  doesNotContainSuffix: "SANS",
  traditionalMethodsLine1: "Préparé selon des méthodes traditionnelles,",
  traditionalMethodsLine2: "avec le plus grand soin.",

  // Product Gallery
  clickToCloseZoom: "Cliquez pour fermer le zoom",
  zoomOut: "Dézoomer",
  zoomIn: "Zoomer",

  // Product Reviews
  fillRequiredFields: "Veuillez remplir tous les champs obligatoires.",
  reviewSubmittedPendingApproval: "Votre avis a été soumis pour modération et sera publié une fois approuvé.",
  reviewSubmitFailed: "Impossible d'envoyer votre avis. Veuillez réessayer.",
  outOf5: "sur 5",
  basedOnReviews: "Basé sur {count} avis",
  summarizeExperience: "Résumez votre expérience",
  tellUsExperience: "Parlez-nous de votre expérience avec ce produit",

  // Login Page
  welcomeBack: "Bienvenue",
  loginSubtitle: "Connectez-vous à votre compte",
  exampleEmailPlaceholder: "exemple@email.com",
  password: "Mot de passe",
  enterPasswordPlaceholder: "Entrez votre mot de passe",
  rememberMe: "Se souvenir de moi",
  forgotPasswordLink: "Mot de passe oublié ?",
  loggingIn: "Connexion en cours...",
  or: "ou",
  continueWithGoogle: "Se connecter avec Google",
  dontHaveAccount: "Vous n'avez pas de compte ?",
  signUpNow: "Inscrivez-vous",
  loginErrorGeneric: "Une erreur s'est produite lors de la connexion !",

  // Register Page
  registerSubtitle: "Rejoignez la famille Cuisine Turque",
  firstNameRequired: "Le prénom est requis",
  lastNameRequired: "Le nom est requis",
  emailRequired: "L'adresse e-mail est requise",
  invalidEmail: "Entrez une adresse e-mail valide",
  passwordRequired: "Le mot de passe est requis",
  passwordMinLength: "Le mot de passe doit contenir au moins 6 caractères",
  passwordsDoNotMatch: "Les mots de passe ne correspondent pas",
  cityRequired: "La sélection de la ville est requise",
  agreeTermsRequired: "Vous devez accepter les conditions générales",
  registerErrorGeneric: "Une erreur s'est produite lors de l'inscription !",
  firstNamePlaceholder: "Votre prénom",
  lastNamePlaceholder: "Votre nom",
  phonePlaceholderExample: "0455 12 34 56",
  cityDeliveryHelperText: "Nécessaire pour afficher la disponibilité du paiement à la livraison et les jours de livraison.",
  passwordMinCharsPlaceholder: "Au moins 6 caractères",
  confirmPassword: "Confirmer le Mot de Passe",
  confirmPasswordPlaceholder: "Ressaisissez votre mot de passe",
  wantMarketingEmails: "Je souhaite recevoir des e-mails sur les promotions et les nouveautés.",
  registering: "Inscription en cours...",
  registerWithGoogle: "S'inscrire avec Google",
  alreadyHaveAccount: "Vous avez déjà un compte ?",
  loginNow: "Connectez-vous",

  // Forgot / Reset Password
  forgotPasswordTitle: "Mot de Passe Oublié",
  forgotPasswordDescription: "Entrez votre adresse e-mail et nous vous enverrons un lien de réinitialisation.",
  resetLinkSentDefault: "Lien de réinitialisation envoyé.",
  genericErrorRetry: "Une erreur s'est produite. Veuillez réessayer.",
  checkSpamReminder: "N'oubliez pas de vérifier également votre dossier spam.",
  sendResetLink: "Envoyer le Lien de Réinitialisation",
  backToLoginLink: "Retour à la Connexion",
  invalidLinkTitle: "Lien Invalide",
  invalidLinkDesc: "Le lien de réinitialisation du mot de passe est manquant ou invalide.",
  requestNewLink: "Demander un nouveau lien",
  setNewPasswordTitle: "Définir un Nouveau Mot de Passe",
  minCharsHint: "Utilisez au moins 6 caractères.",
  passwordResetSuccessDefault: "Votre mot de passe a été réinitialisé avec succès.",
  invalidOrExpiredLink: "Lien invalide ou expiré.",
  redirectingToLogin: "Vous allez être redirigé vers la page de connexion...",
  newPassword: "Nouveau Mot de Passe",
  saving: "Enregistrement...",
  resetPasswordButton: "Réinitialiser Mon Mot de Passe",

  // OAuth Callback
  invalidLoginLink: "Le lien de connexion est invalide.",
  loginFailedGeneric: "Échec de la connexion.",
  loggingInEllipsis: "Connexion en cours…",

  // Profile Page
  myProfile: "Mon Profil",
  manageAccountInfo: "Gérez les informations de votre compte",
  myOrders: "Mes Commandes",
  security: "Sécurité",
  memberSince: "Membre depuis",
  favoriteProducts: "Produits Favoris",
  averageRating: "Note Moyenne",
  itemsCountSuffix: "articles",
  details: "Détails",
  noOrdersYet: "Vous n'avez pas encore passé de commande",
  discoverProductsForFirstOrder: "Découvrez nos produits pour passer votre première commande",
  myFavoriteProducts: "Mes Produits Favoris",
  noFavoritesYet: "Vous n'avez pas encore de produits favoris",
  addFavoritesHint: "Ajoutez les produits que vous aimez à vos favoris",
  exploreProducts: "Découvrir les Produits",
  securitySettings: "Paramètres de Sécurité",
  changePassword: "Changer le Mot de Passe",
  lastPasswordChange: "Dernière modification : il y a 3 mois",
  changeAction: "Modifier",
  twoFactorAuth: "Authentification à Deux Facteurs",
  twoFactorAuthDesc: "Renforcez la sécurité de votre compte",
  enableAction: "Activer",
  sessionHistory: "Historique des Sessions",
  sessionHistoryDesc: "Consultez vos sessions actives",
  profileUpdateError: "Une erreur s'est produite lors de la mise à jour de votre profil. Veuillez réessayer.",
  orderStatusPending: "en attente",
  orderStatusConfirmed: "confirmée",
  orderStatusProcessing: "en préparation",
  orderStatusShipped: "expédiée",
  orderStatusDelivered: "livrée",
  orderStatusCancelled: "annulée",
  orderStatusRefunded: "remboursée",
  orderStatusNotification: "Votre commande {orderNumber} : {status}",

  // Email Notification Settings
  loadPreferencesError: "Une erreur s'est produite lors du chargement de vos préférences de notification",
  userNotFound: "Informations utilisateur introuvables",
  saveSettingsError: "Une erreur s'est produite lors de la mise à jour des paramètres",
  emailSettingsUpdated: "Paramètres e-mail mis à jour avec succès !",
  selectEmailsToReceive: "Choisissez les e-mails que vous souhaitez recevoir",
  currentFrequencyLabel: "Fréquence actuelle :",
  weeklyEmailLimitText: "Maximum 2-3 e-mails par semaine",

  // Natural Ingredients Page
  naturalIngredientsTitle: "🌿 Ingrédients Naturels",
  naturalIngredientsIntro: "Nous préparons nos produits en utilisant uniquement les meilleurs ingrédients naturels et frais. Aucun conservateur, édulcorant artificiel ou additif.",
  naturalIngredients100Title: "100 % d'Ingrédients Naturels",
  naturalIngredientsDesc1: "En tant que Cuisine Turque, nous utilisons uniquement des ingrédients naturels et biologiques dans nos produits. Tout en préservant nos recettes traditionnelles, nous appliquons également des normes d'hygiène modernes.",
  naturalIngredientsListIntro: "Les ingrédients que nous utilisons dans chaque produit :",
  ingredientHoney: "Variétés de miel naturel",
  ingredientWalnut: "Noix et pistaches biologiques",
  ingredientFlour: "Variétés de farine traditionnelle",
  ingredientAroma: "Arômes et épices naturels",
  ingredientSugar: "Sucre et édulcorants biologiques",
  naturalHoneyTitle: "Miel Naturel",
  naturalHoneyDesc: "Nos variétés de miel naturel sélectionnées parmi les meilleurs miels d'Anatolie",
  organicWalnutTitle: "Noix Biologiques",
  organicWalnutDesc: "Des saveurs traditionnelles avec nos noix et pistaches fraîches",
  traditionalFlourTitle: "Farine Traditionnelle",
  traditionalFlourDesc: "Nos variétés de farine produites selon des méthodes traditionnelles",
  qualityCertificatesTitle: "Nos Certificats de Qualité",
  halalCertTitle: "Certificat Halal",
  halalCertDesc: "Tous nos produits sont certifiés halal",
  organicCertTitle: "Certificat Biologique",
  organicCertDesc: "Nos ingrédients sont certifiés biologiques",
  discoverNaturalIngredientsTitle: "Découvrez Nos Ingrédients Naturels",
  discoverNaturalIngredientsDesc: "Parcourez nos produits fabriqués avec des ingrédients naturels et passez votre commande",
  reviewOurProducts: "Découvrir Nos Produits",

  // Master Hands Page
  masterHandsTitle: "👩‍🍳 Mains Expertes",
  masterHandsIntro: "Chacun de nos produits est préparé avec des années d'expérience et d'amour. Nous mêlons nos recettes traditionnelles à des techniques modernes.",
  traditionalRecipesTitle: "Recettes Traditionnelles",
  masterHandsDesc1: "Nous présentons nos recettes traditionnelles, transmises par nos grands-parents, mêlées à des normes d'hygiène modernes.",
  masterHandsListIntro: "Les qualités de nos mains expertes :",
  masterHandsFeature1: "Une expérience transmise sur 3 générations",
  masterHandsFeature2: "La préservation des recettes traditionnelles",
  masterHandsFeature3: "Des normes d'hygiène modernes",
  masterHandsFeature4: "La chaleur familiale dans chaque produit",
  masterHandsFeature5: "Un contrôle qualité rigoureux",
  masterMehmetName: "Maître Mehmet",
  masterMehmetDesc: "30 ans d'expérience, maître baklava traditionnel",
  masterFatmaName: "Madame Fatma",
  masterFatmaDesc: "Experte en helva et sucuk, 25 ans d'expérience",
  masterAliName: "Maître Ali",
  masterAliDesc: "Expert en miel, 20 ans d'expérience apicole",
  productionProcessTitle: "Notre Processus de Production",
  processStep1Title: "Sélection des Ingrédients",
  processStep1Desc: "Nous sélectionnons les meilleurs ingrédients",
  processStep2Title: "Recette Traditionnelle",
  processStep2Desc: "Nous appliquons les recettes de nos grands-parents",
  processStep3Title: "Mains Expertes",
  processStep3Desc: "Nos maîtres expérimentés les préparent",
  processStep4Title: "Contrôle Qualité",
  processStep4Desc: "Nous soumettons chaque produit à un contrôle qualité",
  discoverMasterHandsTitle: "Découvrez le Travail de Nos Mains Expertes",
  discoverMasterHandsDesc: "Parcourez nos produits préparés avec des recettes traditionnelles et passez votre commande",

  // Fast Delivery Page
  fastDeliveryTitle: "🚚 Livraison Rapide",
  fastDeliveryIntro: "Nous livrons vos produits frais à votre porte dans les plus brefs délais. Nous offrons un emballage spécial et une garantie de livraison sécurisée.",
  fastSecureDeliveryTitle: "Livraison Rapide et Sécurisée",
  fastDeliveryDesc1: "Nous livrons vos commandes à votre porte dans les plus brefs délais. Nous transportons nos produits frais en toute sécurité dans un emballage spécial.",
  fastDeliveryListIntro: "Nos caractéristiques de livraison :",
  deliveryFeature1: "Livraison sous 24 heures",
  deliveryFeature2: "Emballage spécial chaîne du froid",
  deliveryFeature3: "Emballage sécurisé",
  deliveryFeature4: "Option de paiement à la livraison",
  deliveryFeature5: "Livraison gratuite (au-delà de 150 TL)",
  fastDeliveryCardTitle: "Livraison Rapide",
  fastDeliveryCardDesc: "Garantie de livraison sous 24 heures",
  specialPackagingTitle: "Emballage Spécial",
  specialPackagingDesc: "Emballage sécurisé avec chaîne du froid",
  secureDeliveryTitle: "Livraison Sécurisée",
  secureDeliveryDesc: "Paiement à la livraison et livraison sécurisée",
  deliveryProcessTitle: "Notre Processus de Livraison",
  deliveryStep1Title: "Réception de la Commande",
  deliveryStep1Desc: "Nous recevons votre commande",
  deliveryStep2Title: "Préparation",
  deliveryStep2Desc: "Nous préparons les produits frais",
  deliveryStep3Title: "Emballage",
  deliveryStep3Desc: "Nous les emballons dans un emballage spécial",
  deliveryStep4Title: "Livraison",
  deliveryStep4Desc: "Nous livrons à votre porte",
  deliveryAreasTitle: "Nos Zones de Livraison",
  deliveryFeesTitle: "Frais de Livraison",
  deliveryFeeOver50: "Commandes de plus de 50 € :",
  deliveryFeeFree: "GRATUIT",
  deliveryFeeUnder50: "Commandes de moins de 50 € :",
  deliveryFeeFast: "Livraison rapide (12 heures) :",
  orderNowWithFastDelivery: "Commandez avec la Livraison Rapide",
  orderNowWithFastDeliveryDesc: "Nous livrons vos produits frais à votre porte avec une livraison rapide",
  orderNowButton: "Commander Maintenant",

  // Return Request Page
  reasonDamaged: "Produit Endommagé / Défectueux",
  reasonWrongItem: "Mauvais Article Envoyé",
  reasonNotAsDescribed: "Ne Correspond Pas à la Description",
  reasonChangedMind: "Changement d'Avis",
  orderNotFoundPeriod: "Commande introuvable.",
  orderNotFoundForNumber: "Aucune commande trouvée avec ce numéro de commande.",
  returnRequestSubmitError: "La demande n'a pas pu être envoyée. Veuillez réessayer.",
  returnRequestReceivedTitle: "Votre Demande de Retour a Été Reçue",
  returnRequestReceivedDesc: "Votre demande est en cours d'examen. Vous serez informé par e-mail dans les plus brefs délais.",
  trackTheOrder: "Suivre la Commande",
  returnRequestPageDesc: "Vous pouvez soumettre une demande de retour pour vos commandes livrées.",
  orderInfoTitle: "Informations sur la Commande",
  orderNumberLabel: "Numéro de Commande",
  orderNumberPlaceholder: "Ex : 1234567890",
  findOrderButton: "Trouver la Commande",
  orderAmountLabel: "Montant",
  returnDeliveredOnlyNotice: "Une demande de retour ne peut être créée que pour les commandes livrées.",
  returnReasonTitle: "Motif du Retour",
  returnDescriptionLabel: "Description",
  optionalFieldLabel: "(facultatif)",
  returnDescriptionPlaceholder: "Partagez des informations supplémentaires sur votre retour...",
  submitReturnRequest: "Envoyer la Demande de Retour",

  // 3D Flipbook Brochure Gourmande
  flipbookSectionBadge: "SÉLECTION DÉGUSTATION INTERACTIVE",
  flipbookSectionTitle: "Brochure Dégustation d'Anatolie",
  flipbookSectionSubtitle: "Tournez les pages pour découvrir les sélections artisanales et les coupons de réduction exclusifs.",
  flipbookTabCover: "📖 Couverture",
  flipbookCoverBadge: "SÉLECTION SPÉCIALE 2026",
  flipbookCoverTitle: "Saveurs d'Anatolie",
  flipbookCoverSubtitle: "Catalogue Artisanal Traditionnel & Offres Spéciales",
  flipbookCoverDescription: "Recettes séculaires, moulins en pierre et chaudrons en cuivre apportant un héritage gastronomique à votre table.",
  flipbookCoverTagline: "📖 Tournez la page pour découvrir les saveurs authentiques d'Anatolie",
  flipbookCoverCouponTitle: "Remise Catalogue",
  flipbookCoverCouponDiscount: "15% de Réduction de Bienvenue",
  flipbookOpenCatalog: "Ouvrir le Catalogue",
  flipbookTurnPage: "Tourner ❯",
  flipbookPrevPage: "Page Précédente",
  flipbookNextPage: "Page Suivante",
  flipbookPageCount: "Page",
  flipbookAutoPlayActive: "⏱️ Défilement Automatique",
  flipbookAutoPlayPaused: "⏸️ En Pause (Survol)",
  flipbookPause: "Pause",
  flipbookPlay: "Lire",
  flipbookLimitedOffer: "🔥 Cette offre est valable pour une durée limitée.",
  flipbookInspectAndBuy: "Voir & Acheter Maintenant",
  flipbookTastingPortion: "Portion Dégustation / Coffret Cadeau",
  flipbookNextPageHint: "Tourner vers la page suivante ❯",
  flipbookCatalogTitleFooter: "Catalogue Saveurs d'Anatolie",

  // Flipbook Contenu d'exemple
  flipbookCatDesserts: "Desserts Traditionnels",
  flipbookTagStar: "Étoile du Jour",
  flipbookBaklavaTitle: "Baklava Carotte & Pistaches d'Antep",
  flipbookBaklavaSubtitle: "Pistaches Émeraude de Gaziantep & Beurre Clarifié Pur",
  flipbookBaklavaStory: "40 couches de pâte filo extra fine cuites au feu de bois de chêne. Une symphonie croustillante.",
  flipbookBaklavaFeat1: "100% Sucre de Betterave Naturel",
  flipbookBaklavaFeat2: "Beurre Clarifié Traditionnel d'Urfa",
  flipbookBaklavaFeat3: "Fabrication Fraîche Quotidienne",

  flipbookCatDeli: "Petit-Déjeuner & Épicerie Fine",
  flipbookTagArtisan: "Sélection d'Artisan",
  flipbookCheeseTitle: "Kashar Affiné de Kars & Fromages Gourmets",
  flipbookCheeseSubtitle: "Des Pâturages à 2400m d'Altitude à Votre Table",
  flipbookCheeseStory: "Fabriqué exclusivement avec le lait d'été de vaches en liberté, affiné naturellement 12 mois dans des grottes.",
  flipbookCheeseFeat1: "12 Mois d'Affinage Naturel",
  flipbookCheeseFeat2: "Sans Additifs ni Conservateurs",
  flipbookCheeseFeat3: "Livraison Express en Chaîne du Froid",

  flipbookCatNatural: "Naturel & Bien-être",
  flipbookTagPure: "Héritage Pur",
  flipbookOilHoneyTitle: "Miel Sauvage & Huile d'Olive Première Pression",
  flipbookOilHoneySubtitle: "Les Remèdes les Plus Purs de la Nature en un Coffret",
  flipbookOilHoneyStory: "Huile d'olive extra vierge des pentes du Mont Ida associée au miel sauvage pur des hauts plateaux.",
  flipbookOilHoneyFeat1: "Taux d'Acidité < 0.3%",
  flipbookOilHoneyFeat2: "Miel Brut Certifié en Laboratoire",
  flipbookOilHoneyFeat3: "Coffret Protecteur en Bois",

  flipbookCatTreats: "Douceurs & Loukoums",
  flipbookTagPalace: "Tradition du Palais",
  flipbookLokumTitle: "Loukoum aux Pistaches Grillées",
  flipbookLokumSubtitle: "Cuit dans des Chaudrons de Cuivre au Feu de Bois",
  flipbookLokumStory: "Préparé selon la recette du palais ottoman, alliant jus de grenade frais et pistaches d'Antep doublement torréfiées.",
  flipbookLokumFeat1: "Sans Gélatine & Sans Gluten",
  flipbookLokumFeat2: "Généreusement Garni de Pistaches",
  flipbookLokumFeat3: "Présenté en Coffret Cadeau"
};
